exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "input {\n  -o-text-overflow: ellipsis;\n     text-overflow: ellipsis; }\n\n.form-control {\n  background-color: #fff; }\n", ""]);

